import React from "react";
import { Fade } from "react-awesome-reveal";
import icon from "../../../images/icon/Buga/data-layer.svg";
import icon1 from "../../../images/icon/Buga/voice-icon.png";
import icon2 from "../../../images/icon/Buga/email-icon.png";
import icon3 from "../../../images/icon/Buga/chat-icon.png";
import icon4 from "../../../images/icon/Buga/analyze-icon.png";
import icon5 from "../../../images/icon/Buga/black-arrow.png";
import icon7 from "../../../images/icon/Buga/manage-icon.png";
import icon8 from "../../../images/icon/Buga/service-icon.png";
import icon9 from "../../../images/icon/Buga/contact-icon.png";
import logo from "../../../images/logo/logo-black.png";

const FeaturesService = (props) => {
  return (
    <section
      id="features"
      className="feature pt-70 pb-130 o-hidden"
      style={{ backgroundColor: "#f6f0e6" }}
    >
      <div className="container">
        <div className="xb-feature-wrap pos-rel">
          <div className="sec-title--two sec-title--four text-center mb-65">
            <Fade
              direction="down"
              triggerOnce={"false"}
              duration={1000}
              delay={9}
            >
              <div>
                <div
                  className="sub-title wow fadeInDown"
                  data-wow-duration="600ms"
                >
                  <img src={icon} alt="" />
                  Money Transfer Services
                </div>
              </div>
            </Fade>
            <Fade
              direction="down"
              triggerOnce={"false"}
              duration={1500}
              delay={9}
            >
              <div>
                <h2
                  className="title wow fadeInDown"
                  data-wow-delay="150ms"
                  data-wow-duration="600ms"
                >
                  Why Choose Us for Remittance?
                </h2>
              </div>
            </Fade>
          </div>
          <div className="hd-feature--top">
            <div className="hd-feature-item text-center">
              <h3 className="xb-item--title">Fast Transfers</h3>
              <p className="xb-item--content">
                Quick and secure money transfers across countries with real-time
                tracking.
              </p>
              <ul className="xb-item--meta list-unstyled">
                <li>
                  <a
                    style={{ color: "#f6f0e6e6" }}
                    href="tel:+447459852485"
                    className="hover-yellow"
                  >
                  <img src={icon1} alt="" />
                  <span>Voice Support</span>
                  </a>
                </li>
                <li>
                  <a
                  
                    style={{ color: "#f6f0e6e6" }}
                    href="mailto:info@bugamoney.com"
                    className="hover-yellow"
                  >
                    <img src={icon2} alt="" />
                    <span>Email Support</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/447459852485?text=Hello%20I%20want%20to%20know%20more%20about%20your%20money%20transfer%20services"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover-yellow"
                  >
                    <img src={icon3} alt="" />
                    <span>Chat Support</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="hd-feature--middle">
            <div className="hd-feature-item">
              <img src={icon4} alt="" />
              <h3 className="xb-item--title">Track & Analyze</h3>
              <p className="xb-item--content">
                Track your transactions and monitor transfer status in
                real-time.
              </p>
            </div>
            <div className="hd-button-box pos-rel">
              <a href="/" className="hd-feature-button">
                <span>
                  <img src={logo} style={{ maxWidth: "200px" }} alt="" />
                </span>
              </a>
              <div className="xb-arrow">
                <div className="arrow arrow--one">
                  <img src={icon5} alt="" />
                </div>
                <div className="arrow arrow--two">
                  <img src={icon5} alt="" />
                </div>
                <div className="arrow arrow--three">
                  <img src={icon5} alt="" />
                </div>
                <div className="arrow arrow--four">
                  <img src={icon5} alt="" />
                </div>
              </div>
            </div>
            <div className="hd-feature-item">
              <img src={icon7} alt="" />
              <h3 className="xb-item--title">Manage Transfers</h3>
              <p className="xb-item--content">
                Easily manage beneficiaries, transfer history, and payment
                methods.
              </p>
            </div>
          </div>
          <div className="hd-feature--bottom">
            <div className="hd-feature-item text-center">
              <h3 className="xb-item--title">Reliable Assistance</h3>
              <p className="xb-item--content">
                24/7 customer support to guide you through every step of your
                money transfer.
              </p>
              <ul className="xb-item--meta list-unstyled ul_li_between">
                <li>
                  <img src={icon8} alt="" />
                  <span>Global Services</span>
                </li>
                <li>
                  <img src={icon9} alt="" />
                  <span>Customer Care</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="xb-shape">
            <span></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesService;
